<div style="width: auto; min-width: 220px;">
  <button class="menu-button" mat-menu-item routerLink="/profile">
    <div class="popup-header">
      <div><b>{{username | async}}</b></div>
      <div fxFlex="auto" class="companyName">{{companyName}}</div>
      <div *ngIf="accountNumber | async" style="line-height: 1em; padding-bottom: 12px">
        {{ accountNumber | async }}
      </div>
    </div>
  </button>

  <mat-divider></mat-divider>

  <button class="menu-button" mat-menu-item routerLink="/profile/personal-information">
    <div
      class="global-icon"
      style="
        width: 24px; height: 24px;
        -webkit-mask-image: url('assets/icons/person_circle.svg');
        mask-image: url('assets/icons/person_circle.svg');
        margin-right: 8px;
        vertical-align: middle;
      "
      aria-label="account information"
    ></div>
    <span style="vertical-align: middle;">Profil</span>
  </button>

  <button class="menu-button" mat-menu-item routerLink="/profile/company">
    <div
      class="global-icon"
      style="
        width: 24px; height: 24px;
        -webkit-mask-image: url('assets/icons/business.svg');
        mask-image: url('assets/icons/business.svg');
        margin-right: 8px;
        vertical-align: middle;
      "
      aria-label="company"
    ></div>
    <span style="vertical-align: middle;">Entreprise</span>
  </button>

  <button class="menu-button" mat-menu-item routerLink="/profile/outstanding">
    <div
      class="global-icon"
      style="
        width: 24px; height: 24px;
        -webkit-mask-image: url('assets/icons/euro.svg');
        mask-image: url('assets/icons/euro.svg');
        margin-right: 8px;
        vertical-align: middle;
      "
      aria-label="outstanding"
    ></div>
    <span style="vertical-align: middle;">Encours</span>
  </button>

  <button class="menu-button" mat-menu-item routerLink="/profile/address-book">
    <div
      class="global-icon"
      style="
        width: 24px; height: 24px;
        -webkit-mask-image: url('assets/icons/pin_drop.svg');
        mask-image: url('assets/icons/pin_drop.svg');
        margin-right: 8px;
        vertical-align: middle;
      "
      aria-label="addresses"
    ></div>
    <span style="vertical-align: middle;">Adresses</span>
  </button>

  <button class="menu-button" mat-menu-item routerLink="/profile/quotations">
    <div
      class="global-icon"
      style="
        width: 24px; height: 24px;
        -webkit-mask-image: url('assets/icons/file_copy.svg');
        mask-image: url('assets/icons/file_copy.svg');
        margin-right: 8px;
        vertical-align: middle;
      "
      aria-label="devis"
    ></div>
    <span style="vertical-align: middle;">Devis</span>
  </button>

  <!-- Keep the red shopping cart as <img> because it’s colored -->
<button class="menu-button" mat-menu-item routerLink="/profile/orders" style="display: flex; align-items: center;">
  <div
    class="global-icon"
    style="
      width: 24px; height: 24px;
      -webkit-mask-image: url('assets/icons/shopping_cart-red.svg');
      mask-image: url('assets/icons/shopping_cart-red.svg');
      margin-right: 8px;
      vertical-align: middle;
    "
    aria-label="order"
  ></div>
  <span style="vertical-align: middle;">Commandes</span>
</button>


  <button class="menu-button" mat-menu-item routerLink="/profile/invoices">
    <div
      class="global-icon"
      style="
        width: 24px; height: 24px;
        -webkit-mask-image: url('assets/icons/assignment.svg');
        mask-image: url('assets/icons/assignment.svg');
        margin-right: 8px;
        vertical-align: middle;
      "
      aria-label="invoices"
    ></div>
    <span style="vertical-align: middle;">Factures</span>
  </button>

  <mat-divider></mat-divider>

  <button class="menu-button" mat-menu-item (click)="onLogOut()">
    <span style="vertical-align: middle;">Se déconnecter</span>
  </button>
</div>
